//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





export default {

  data() {
    return {
      name:'',
      company:'',
      count:'',
      recruitAddress:'',
      education:'',
      age:'',
      request:'',
      salary:'',
      rest:'',
      boardLodging:'',
      contact:'',
      phone:'',
      unitAddress:'',
      traffic:'',
      createDate:'',
      endDate:''
    };
  },
  /**
   * The methods the page can use.
   */
  methods: {

    /**
     * Will log the user in.
     *
     * @param {Object} user The user to be logged in.
     */

  },
  mounted () {
    this.name = this.$route.query.name;
    this.company = this.$route.query.company;
    this.count = this.$route.query.count;
    this.age = this.$route.query.age;
    this.recruitAddress = this.$route.query.recruitAddress;
    this.education = this.$route.query.education;
    this.request = this.$route.query.request;
    this.salary = this.$route.query.salary;
    this.rest = this.$route.query.rest;
    this.boardLodging = this.$route.query.boardLodging;
    this.contact = this.$route.query.contact;
    this.phone = this.$route.query.phone;
    this.unitAddress = this.$route.query.unitAddress;
    this.traffic = this.$route.query.traffic;
    this.createDate = this.$route.query.createDate;
    this.endDate = this.$route.query.endDate;
  },

};



// WEBPACK FOOTER //
// ./src/pages/gw/detail.vue